import { render } from "./GreenCat.svg?vue&type=template&id=cfddca50"
const script = {}
script.render = render

export default script